import axiosInstance from '../helpers/axiosInstance'

export const sendReturnCameraEvent = async (payload) => {
  const res = await axiosInstance.post(
    `${process.env.REACT_APP_PLATFORM_URL}/api/v1/returns-proof/camera-events`,
    payload,
  )
  return res.data
}
